/**
 * The opened cloud-credential (🔑) portfolio's table — pure, so the column
 * rules are tested without rendering.
 *
 * Port of legacy views/CloudUsagesReport/ListOfInstances.vue (headers
 * :116-143, modifiedInstances :162-167, os cell :37-39). Labels and keys
 * verbatim; legacy's empty trailing "actions" column is left out.
 */

/** The instance's name, or its uuid (legacy `instance_name || uuid`). */
function nameOf(row) {
  return row?.instance_name || row?.uuid || '';
}

/** "linux" -> "Linux" (legacy capitalised the OS, '-' when missing). */
function osOf(row) {
  const os = String(row?.os_type ?? '');
  return os ? os.charAt(0).toUpperCase() + os.slice(1) : '';
}

const COLUMNS = Object.freeze({
  cca: Object.freeze([
    { key: 'instance_name', header: 'UUID / Instance Name', read: nameOf },
    { key: 'region', header: 'Region' },
    { key: 'instance type', header: 'Size' },
    { key: 'os_type', header: 'Operating System', read: osOf },
    { key: 'quantity', header: 'Quantity', numeric: true },
    { key: 'monthly utilization (hourly)', header: 'No. of Hours', numeric: true },
    { key: 'pricingModel', header: 'Pricing Model' },
  ]),
  eia: Object.freeze([
    { key: 'instance_name', header: 'UUID/Instance Name', read: nameOf },
    { key: 'region', header: 'Region' },
    { key: 'instance type', header: 'Instance Type' },
    { key: 'os_type', header: 'OS Type', read: osOf },
    { key: 'max cpu%', header: 'CPU(%)', numeric: true },
    { key: 'max mem used', header: 'Memory(GB)', numeric: true },
    { key: 'max disk bw used', header: 'Disk(GB)', numeric: true },
    { key: 'max network bw', header: 'Network(Mbps)', numeric: true },
    { key: 'max iops', header: 'IOPS', numeric: true },
    { key: 'uavg', header: 'UAVG', numeric: true },
    { key: 'u95', header: 'U95', numeric: true },
  ]),
});

/** The 🔑 view's columns for a product ('cca' | 'eia'), each with how to read its cell. */
export function cloudCredentialColumns(mode) {
  return (COLUMNS[mode] ?? COLUMNS.eia).map((c) => ({
    ...c,
    read: c.read ?? ((row) => row?.[c.key]),
  }));
}
